
import React from 'react';
import PowerQualityCharts from './PowerQualityCharts';

const PowerQualityTab = () => {
  return (
    <div className="space-y-6">
      <PowerQualityCharts />
    </div>
  );
};

export default PowerQualityTab;
